import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    popupAnchor: null,
    popupValue: null,
    popupRowId: null,
    selectedTab: 0,
  };
  
  const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
      showPopup: (state, action) => {
        return {...state, ...{popupAnchor: action.payload.anchor, popupValue: action.payload.value, popupRowId: action.payload.rowId }}
      },
      hidePopup: (state) => {
        return {...state, ...{popupAnchor: null, popupValue: null}}
      },
      setSelectedTab: (state, action) => {
        return {...state,...{selectedTab: action.payload}}
      }
    }
  });
  
  export const { showPopup, hidePopup, setSelectedTab } = uiSlice.actions;
  export default uiSlice.reducer;